module.exports = __webpack_public_path__ + "static/media/100 - Allah-Las - Catamaran.160d253d.mp3";